import { render, staticRenderFns } from "./modalLoading.vue?vue&type=template&id=55fb5101&scoped=true&"
import script from "./modalLoading.vue?vue&type=script&lang=js&"
export * from "./modalLoading.vue?vue&type=script&lang=js&"
import style0 from "./modalLoading.vue?vue&type=style&index=0&id=55fb5101&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fb5101",
  null
  
)

export default component.exports